/**
 * Shared centered card shell for Login / Signup / OTP / Onboarding.
 * Brand: navy #0b1f4a, gold accent, Classical tokens when available.
 */
import type { ReactNode } from 'react';
import './auth-shell.css';

type AuthShellProps = {
  children: ReactNode;
  /** Hide logo/tagline block (e.g. mid-flow) */
  showBrand?: boolean;
};

export function AuthShell({ children, showBrand = true }: AuthShellProps) {
  return (
    <div className="auth-shell">
      <div className="auth-card">
        {showBrand && (
          <div className="auth-brand">
            <div className="auth-logo" aria-hidden>
              GE
            </div>
            <div className="auth-title">GDPR Nordic</div>
            <div className="auth-tagline">Din rätt. Dina uppgifter. Ditt skydd.</div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export default AuthShell;
